<template>
	<div>
		<nav class="nav w100 header bg-white-base content col-offset-lg-1 col-lg-10 col-12 margin-0 display-flex align-items-center justify-content-between" :class="{ 'position-fixed': isOpen }">
			<b-router-link to="/">
					<bbox-icon class="icon">
						<icon-bossabox class="logo"></icon-bossabox>
					</bbox-icon>
			</b-router-link>

			<div class="position-relative nav-actions" @click="handleSwitchMenu">
				<BNewBIconMenu v-if="!isOpen" class="icon-menu" />
				<BNewBIconClose v-else class="icon-close" />
			</div>
		</nav>
		<div v-if="isOpen" class="navbar-mobile-content position-fixed bg-white-base w100 border-top border-white-darker-4">
			<slot name="openedContent">
			</slot>
		</div>
	</div>
</template>

<script>
import BRouterLink from './RouterLink.vue';
import IconBossabox from '../icons/icon-bossabox.svg';
import BboxIcon from './Icon.vue';
import { BNewBIconMenu, BNewBIconClose } from './new_icons'

export default {
	name: 'b-nav-mobile',
	components: {
		BRouterLink,
		IconBossabox,
		BboxIcon,
		BNewBIconMenu,
		BNewBIconClose
	},
	props: {
		isOpen: Boolean
	},
	methods: {
		handleSwitchMenu() {
			this.$emit('handleSwitchMenu')
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@bossabox-code/design-system/css/_variables.scss';
@import '@bossabox-code/design-system/css/spacing.scss';
.nav {
	z-index: 10;
	top: 0;
	height: 6.4rem;
}

.icon {
	transform: translate(0);
}

.logo {
	font-size: 3.9rem;
}

.icon-menu {
	width: 4.5rem;
	height: 4.5rem;
}

.icon-close {
	width: 3.2rem;
	height: 3.2rem;
	margin-right: 0.6rem;
}

.navbar-mobile-content {
	height: calc(100vh - 6.4rem);
	z-index: 10;
	top: 6.4rem;
}
</style>

<docs>
    ```js
    <b-nav-mobile 
			@handleSwitchMenu="methodToToggleMenu"
      :displayMobileMenuContent="displayMobileMenuContent"
		/>
    ```
</docs>
